import { combineReducers } from 'redux';
import SurveyLibraryGridReducer from '../grid/SurveyLibraryGridCreate';
import SurveyLibraryFacetReducer from '../facet/SurveyLibraryFacet';
// WIP: Need to add error states for errored API requests

export default combineReducers({
  SurveyLibraryGridReducer,
  SurveyLibraryFacetReducer
});
